// 与后端 CompanyScopePolicy、用户手册一致：按排除法分类。
// 以下四种角色之外的有效角色（含自定义角色）均为公司管理；空角色不授予身份。
export const NON_COMPANY_MANAGEMENT_ROLES = Object.freeze(['工人师傅', '网点客服', '网点师傅', '网点库管']);
export function hasCompanyManagementRole(roles) {
  return Array.isArray(roles) && roles.some(role => role && role.roleName && !NON_COMPANY_MANAGEMENT_ROLES.includes(role.roleName));
}
